export const CANCELLATION_SOURCE = "eqxCancellationSourceName";
export const CURRENT_URL = "eqxCurrentUrl";
export const JOIN_LEAD_FLOW_EXIT_PATH = "eqxJoinLeadFlowExitPath";
export const NEARBY_CLUBS = "eqxNearbyClubs";
export const NO_ONLINE_JOIN_MESSAGE = "eqxNoOnlineJoinMessage";
export const PREVIOUS_URL = "eqxPreviousUrl";
export const SELECTED_CLUB_ID = "eqxSelectedClubId";
export const USER_GEOLOCATION = "eqxUserGeolocation";
export const USER_SESSION = "eqxUserSession";
